module.exports = __webpack_public_path__ + "img/item7-4.0fc1146d.png";